export {
  toggleRegisterCompany,
  sendEmailToRegisterCompany,
  sendEmailContact,
  requestVerifyEmail,
  closeModalError,
  requestLogin,
  requestEmailResetPassword,
  tryAutomaticallyLogin,
  closeSuccessModalCreateLinkVoucher,
  closeErrorModalCreateLinkVoucher,
} from './Landing';

export { startRequest, finishRequest } from './Loading';

export {
  closeModalErrorFailed,
  fetchingCompaniesToUser,
  selectCompany,
  requestSignup,
  closeSignup,
  closeEmailConfirmation,
  setReferalFriendCode,
  setLinkCode,
} from './SignUp';

export {
  onCloseRequestEmailResetPasswordModal,
  resetPassword,
  closeResetPasswordModalError,
  sendRequestChangePassword,
  closeModalFailed,
} from './Password';

export {
  changeMenuTitleHeader,
  changeRestaurantOptions,
  selectAddressForOrder,
  fetchingMenu,
  verifyRestaurantAvailable,
  closeModalAvailableRestaurant,
  selectItemSideBarMenu,
  fetchingRecentlyOrdered,
  fetchingPendingOrderFeedback,
  fetchingProducts,
  fetchingMealOptionsFromPopularDish,
  submitOrderFeedback,
  skipOrderFeedback,
  fetchingListAddressForOrder,
  restaurantSelected,
  categoriesSelected,
  deleteRestaurantSelected,
  selectProduct,
  closeProductDetails,
  logoutRequest,
  logoutSuccess,
  toggleMenuMobile,
  toggleRestaurants,
  handleOrderToRepeat,
  errorHandling,
  fetchingInvoiceInfo,
} from './Menu';

export { fetchingBusinessFromUser } from './Business';

export {
  fetchingCards,
  calculateSubsidy,
  cartSetRestaurantOpen,
  appliedCartValues,
  fetchingCampaignRate,
  triggerModalErrorPlacedOrder,
  closeModalErrorPlacedOrder,
  closeModalPlacedOrderOnCart,
  openModalReceiptOnCart,
  closeModalReceiptOnCart,
  toggleShowModalPlacedOrderOnCart,
  addProductToCart,
  toggleCart,
  deleteProductFromCart,
  deleteAllProductsFromCart,
  placeOrder,
  placeOrderAndPay,
  placeOrderAndGoToAddNewCard,
  cartResetState,
  cartToggleShowModalReceipt,
  toggleIsButtonDisabled,
  handlePayInvoice,
  deleteCard,
  changeDeliveryTomorrow,
} from './Cart';

export { getOrders } from './DeliveryTracking';

export { findVoucherByCode, createLinkVoucher } from './LinkVoucher';

export { fetchingVoucherBalance } from './VoucherBalance';

export {
  closeModalConfirmEmails,
  closeModalPlacedOrder,
  closeModalPlacedOrderAndRedirect,
  closeModalReceiptAndRedirect,
  customerExist,
  fetchTeamVoucherCampaignRate,
  fetchValidTeamVouchers,
  openModalConfirmEmails,
  openModalReceipt,
  teamVoucherFetchingCards,
  teamVoucherSetOrder,
  verifyUnregisteredEmails,
} from './TeamVoucher';

export {
  createCustomerDeliveryAddress,
  getListCustomerDeliveryAddress,
  deleteCustomerDeliveryAddress
} from './Customer'



// WEBPACK FOOTER //
// ./src/store/actions/index.js